/* The mobile navigation panel.

   Deliberately NOT Dawn's menu-drawer: that stays deleted, along with
   component-menu-drawer.css and the details-modal dependency it carries. This
   is the whole behaviour.

   Lives in assets rather than the header section's {% javascript %} block for
   the reason recorded in the spec — section JS only RUNS for sections actually
   on the page, and a linked asset has no such condition. The header is on
   every page today, but that is a fact about the layout, not a guarantee.

   The panel is rendered on every page and hidden by CSS above 750px. It is
   `hidden` at rest so it is out of the accessibility tree until opened. */
(function () {
  const toggle = document.querySelector('[data-nav-toggle]');
  const panel = document.querySelector('[data-nav-panel]');
  if (!toggle || !panel) return;

  const setOpen = (open) => {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('casalta-nav-open', open);
    /* Lock the page behind the panel. Without this the body scrolls under it
       on iOS and the panel appears to drift. */
    document.body.style.overflow = open ? 'hidden' : '';
  };

  const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';

  toggle.addEventListener('click', () => setOpen(!isOpen()));

  /* Any link closes it — including a link to the page you are already on,
     where no navigation happens and the panel would otherwise stay open over
     the content you just asked for. */
  panel.addEventListener('click', (event) => {
    if (event.target.closest('a')) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) {
      setOpen(false);
      toggle.focus();
    }
  });

  /* Resizing past the breakpoint leaves the panel open over a desktop layout
     that has no way to close it — the button it belongs to is display:none up
     there. Close on the way out rather than trapping the visitor. */
  const wide = window.matchMedia('(min-width: 750px)');
  const onWide = (event) => {
    if (event.matches && isOpen()) setOpen(false);
  };
  if (wide.addEventListener) {
    wide.addEventListener('change', onWide);
  } else {
    wide.addListener(onWide);
  }
})();
